import { useState } from 'react';
import { esES, enUS } from '@mui/x-data-grid';
import { MyExportButton } from '../components/partner';
import { useTranslation } from 'react-i18next';
import { DataGridPro } from '@mui/x-data-grid-pro';

export const TableLayout = ({rows, columns, title, name, pinnedRows}) => {

    const {t, i18n} = useTranslation('global')
    const [pageSize, setPageSize] = useState(25);

    const languageTable = i18n.language === 'en' ? enUS.components.MuiDataGrid.defaultProps.localeText : esES.components.MuiDataGrid.defaultProps.localeText

    return (
        <>
            <DataGridPro
                autoHeight
                rows={rows}
                columns={columns}
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
                pagination
                pinnedRows={pinnedRows}
                experimentalFeatures={{ rowPinning: true }}
                localeText={{...languageTable, toolbarColumns: t('tableButtons.columns'), toolbarDensity: t('tableButtons.density'), toolbarExport: t('tableButtons.export') }}
                components={{
                    Toolbar: MyExportButton,
                }}
                componentsProps={{ toolbar: { page: title, name, rows } }}
                sx={{
                    border: '0',
                    '& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle, .css-cc8tf1': {
                        color: 'secondary.main',
                    },
                    '& .MuiDataGrid-cellContent, .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows': {
                        color: 'primary.main',
                    },
                    '& .css-pdct74-MuiTablePagination-selectLabel, .css-levciy-MuiTablePagination-displayedRows': {
                        color: 'secondary.main',
                    }
                }}
            />
        </>
    )
}
